import React from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../feature-module/router/all_routes";

interface NavItem {
  label: string;
  route: string;
}

const ProfileTab: React.FC = () => {
  const location = useLocation();

  const navItems: NavItem[] = [
    { label: "Communication", route: all_routes.communication },
    { label: "Personal", route: all_routes.personal },
    {
      label: "Family Details",
      route: all_routes.familyDependentDetails,
    },
    { label: "Language Proficiency", route: all_routes.languageProficiency },
    { label: "Previous Work Exp", route: all_routes.previousWork },
    { label: "Education", route: all_routes.education },
    { label: "Miscellaneous Details", route: all_routes.miscellaneous },
    { label: "Nominations (PF)", route: all_routes.nominationsPf },
    { label: "Nominations (Gratuity)", route: all_routes.nominationsGratuity },
    { label: "Prev & Sumbmit", route: all_routes.prevsubmit },
    // { label: "My Compensation", route: all_routes.mycompession },
    // { label: "My Documents", route: all_routes.nominationsGratuity },
    // { label: "My Payslip", route: all_routes.mypayslip },
    // { label: "My Confirmation", route: all_routes.nominationsGratuity },
  ];

  const isActive = (route: string): boolean => location.pathname === route;

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex flex-column list-group settings-list">
          {navItems.map((item, index) => (
            <Link
              key={index}
              to={item.route}
              className={`d-inline-flex align-items-center rounded py-2 px-3 ${
                isActive(item.route) ? "active" : ""
              }`}
            >
              {isActive(item.route) && (
                <i className="ti ti-arrow-badge-right me-2" />
              )}
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileTab;
